import { render, staticRenderFns } from "./StandardValuePaymentStep.vue?vue&type=template&id=78a98dcf&scoped=true"
import script from "./StandardValuePaymentStep.vue?vue&type=script&lang=js"
export * from "./StandardValuePaymentStep.vue?vue&type=script&lang=js"
import style0 from "./StandardValuePaymentStep.vue?vue&type=style&index=0&id=78a98dcf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a98dcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a98dcf')) {
      api.createRecord('78a98dcf', component.options)
    } else {
      api.reload('78a98dcf', component.options)
    }
    module.hot.accept("./StandardValuePaymentStep.vue?vue&type=template&id=78a98dcf&scoped=true", function () {
      api.rerender('78a98dcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/components/StandardValuePaymentStep.vue"
export default component.exports